import { getActiveEnvProfile } from "@/utils/utils";
import { AgentStatus } from "../agent/enums";
import { useCurrentAgentAccount, useIsCurrentAgentTypePlus, useIsSystemAdmin } from "../auth/hooks";

// Overviews and the business coefficients on the contract detail are not released yet, so on production only system
// admins see them
export const useIsOverviewsEnabled = () => {
  const isSystemAdmin = useIsSystemAdmin();

  return getActiveEnvProfile() !== "prod" || !!isSystemAdmin;
};

export const useHasInvestCombinationsAccess = (): boolean => {
  const agentUserAccount = useCurrentAgentAccount();
  const isTopAgentPlus = useIsCurrentAgentTypePlus();
  const isSystemAdmin = useIsSystemAdmin();

  return isTopAgentPlus && (!!isSystemAdmin || agentUserAccount?.agent.status === AgentStatus.BROKER_WITH_CONTRACT);
};
